import { render, staticRenderFns } from "./UpdateCompany.vue?vue&type=template&id=1a7add51&"
import script from "./UpdateCompany.vue?vue&type=script&lang=js&"
export * from "./UpdateCompany.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports